import React, {useState} from "react";
import { ArrowRight } from "react-feather";
import { Divider, Row, Col, Button, Form, Input, Select } from "antd";
import CustomizationService from "../../../services/CustomizationService";


const { Option } = Select;

export default function TechnicalGuide({ onChoosePlan }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onDomainSetupRequest = (formaData) => {
    setLoading(true)
    CustomizationService.createDomainSetupRequest(formaData).then((response) =>{
      console.log(response)
      setLoading(false)
    }).catch(err => {
      setLoading(false)
    })
  }

  return (
    <div className="domain-setup-container">
      <div className="domain-button" onClick={onChoosePlan}>
        Know how to setup a domain? Continue by clicking this box <ArrowRight />
      </div>
      <Divider plain>OR</Divider>
      <div className="tech-suport-container">
        <div>
          No technical expertise? Contact us and we'll help you setup your
          domain
        </div>
        <div>
          <Form form={form} layout="vertical" onFinish={onDomainSetupRequest}>
            <Row gutter={[24, 24]}>
              <Col span="12">
                <Form.Item label="Name" name="name">
                  <Input />
                </Form.Item>
              </Col>
              <Col span="12">
                <Form.Item label="Email" name="email">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 24]}>
              <Col span="12">
                <Form.Item label="Phone Number" name="phone_number">
                  <Input />
                </Form.Item>
              </Col>
              <Col span="12">
                <Form.Item
                  label="Select your Domain Provider"
                  name="domain_provider"
                >
                  <Select>
                    <Option value="godaddy">GoDaddy</Option>
                    <Option value="googleDomain">Google Domain</Option>
                    <Option value="hostinger">Hostinger</Option>
                    <Option value="nameCheap">NameCheap</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 24]}>
              <Col span="12">
                <Form.Item label="Foood Business Name" name="food_business_name">
                  <Input />
                </Form.Item>
              </Col>
              <Col span="12">
                <Form.Item label="Domain Address" name="domain_address">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span="24" className="text-center mt-2">
                <Button type="primary" className="custom-btn" htmlType="submit"
                        disabled={loading}>
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
}
